/**
 * HobbliVision card image layouts.
 * Coordinates are normalized:
 * x = 0-1
 * y = 0-1
 * They work regardless of image resolution.
 */

export const CARD_LAYOUTS = {
    /**
     * Raw ungraded trading card
     */
    RAW_CARD: {
        presentation: "raw",
        regions: {
            top: {
                x: 0,
                y: 0,
                width: 1,
                height: 0.20,
            },
            middle: {
                x: 0,
                y: 0.20,
                width: 1,
                height: 0.60,
            },
            bottom: {
                x: 0,
                y: 0.80,
                width: 1,
                height: 0.20,
            }
        }
    },

    /**
     * PSA graded card
     */
    PSA_SLAB: {
        presentation: "slab",
        grader: "PSA",
        regions: {
            label: {
                x: 0,
                y: 0,
                width: 1,
                height: 0.16,
            },
            card: {
                x: 0,
                y: 0.16,
                width: 1,
                height: 0.70,
            },
            certification: {
                x: 0,
                y: 0.86,
                width: 1,
                height: 0.14,
            }
        }
    },

    /**
     * SGC graded card
     *
     * SGC labels occupy a larger
     * black label area at the top.
     */
    SGC_SLAB: {
        presentation: "slab",
        grader: "SGC",
        regions: {
            label: {
                x: 0,
                y: 0,
                width: 1,
                height: 0.20,
            },

            card: {
                x: 0,
                y: 0.20,
                width: 1,
                height: 0.65,
            },

            certification: {
                x: 0,
                y: 0.85,
                width: 1,
                height: 0.15,
            }
        }
    },

    /**
     * CGC graded card
     */
    CGC_SLAB: {
        presentation: "slab",
        grader: "CGC",
        regions: {
            label: {
                x: 0,
                y: 0,
                width: 1,
                height: 0.18,
            },
            card: {
                x: 0,
                y: 0.18,
                width: 1,
                height: 0.68,
            },
            certification: {
                x: 0,
                y: 0.86,
                width: 1,
                height: 0.14,
            }
        }
    },

    /**
     * Beckett / BGS graded card
     */
    BGS_SLAB: {
        presentation: "slab",
        grader: "BGS",
        regions: {
            label: {
                x: 0,
                y: 0,
                width: 1,
                height: 0.22,
            },
            card: {
                x: 0,
                y: 0.22,
                width: 1,
                height: 0.63,
            },
            certification: {
                x: 0,
                y: 0.85,
                width: 1,
                height: 0.15,
            }
        }
    }
};

/**
 * Default fallback.
 *
 * Used when we cannot determine
 * the card format yet.
 */
export const DEFAULT_CARD_LAYOUT = {
    presentation: "unknown",
    regions: {
        full: {
            x: 0,
            y: 0,
            width: 1,
            height: 1,
        }
    }
};